import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trophy, Lock } from "lucide-react";

export default function Achievements() {
  const [badges, setBadges] = useState([]);
  const [unlocked, setUnlocked] = useState([]);

  useEffect(() => {
    (async () => {
      const [b, u] = await Promise.all([api.get("/curriculum/badges"), api.get("/achievements").catch(() => ({ data: [] }))]);
      setBadges(b.data); setUnlocked(u.data);
    })();
  }, []);

  const unlockedKeys = new Set(unlocked.map((a) => a.badge_key));

  return (
    <div className="space-y-8" data-testid="achievements-page">
      <div>
        <div className="chip mb-2">Progress</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">Your achievements</h1>
        <p className="text-slate-600 mt-1">{unlocked.length} of {badges.length} unlocked.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="badges-grid">
        {badges.map((b) => {
          const on = unlockedKeys.has(b.key);
          return (
            <div key={b.key} data-testid={`badge-${b.key}`}
              className={`p-6 rounded-3xl border transition-all ${on ? "bg-white border-amber-200 shadow-sm" : "bg-slate-50 border-slate-200"}`}>
              <div className={`w-12 h-12 rounded-2xl grid place-items-center ${on ? "bg-amber-100 text-amber-700" : "bg-slate-200 text-slate-400"}`}>
                {on ? <Trophy size={22} strokeWidth={2.4} /> : <Lock size={20} />}
              </div>
              <div className="mt-4 font-display text-lg font-semibold text-slate-900">{b.name}</div>
              <div className="text-sm text-slate-600 mt-1">{b.description}</div>
              {!on && <div className="mt-3 text-xs text-slate-400 uppercase tracking-widest">Locked</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
